import { pipe, map } from "rxjs"
import { Region } from "src/app/core/models/common/region.model"
import { RegioneDto } from "src/app/infrastructure/lobby-proxy/DTOs/regione.dto"

export const mapRegioneDtoToRegion = pipe(
    map((source: RegioneDto) => regioneDtoToRegion(source))
)

export function regioneDtoToRegion(source: RegioneDto): Region {
    return {
        id: source.regioneId,
        name: source.nome
    } as Region
}